"use strict";

exports.__esModule = true;
exports.getTooltip = exports.WellTitle = exports.Well = exports.FlexRow = exports.CheckboxEl = exports.AxisControls = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FlexRow = exports.FlexRow = _styledComponents["default"].div.withConfig({
  displayName: "helper__FlexRow",
  componentId: "sc-tmvejo-0"
})(["display:flex;flex-direction:row;"]);
var AxisControls = exports.AxisControls = _styledComponents["default"].div.withConfig({
  displayName: "helper__AxisControls",
  componentId: "sc-tmvejo-1"
})(["display:flex;> label{margin-right:15px;}"]);
var Well = exports.Well = _styledComponents["default"].div.withConfig({
  displayName: "helper__Well",
  componentId: "sc-tmvejo-2"
})(["padding:7px;border:2px dashed #ddd;margin-bottom:10px;"]);
var WellTitle = exports.WellTitle = _styledComponents["default"].div.withConfig({
  displayName: "helper__WellTitle",
  componentId: "sc-tmvejo-3"
})(["font-weight:bold;margin-bottom:10px;"]);
var CheckboxEl = exports.CheckboxEl = function CheckboxEl(_ref) {
  var propName = _ref.propName,
    defaultLabel = _ref.defaultLabel,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    element = _ref.element,
    elementEditor = _ref.elementEditor,
    path = _ref.path;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: disabled ? "disabled" : "",
    htmlFor: propName
  }, /*#__PURE__*/_react["default"].createElement("input", {
    disabled: disabled,
    id: propName,
    type: "checkbox",
    checked: element.props[propName] || false,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, propName, e.target.checked);
    }
  }), " ", translate("ChartFields.axes." + propName + ".label", defaultLabel));
};
var PopoverContent = _styledComponents["default"].div.withConfig({
  displayName: "helper__PopoverContent",
  componentId: "sc-tmvejo-4"
})(["display:flex;flex-direction:column;padding:10px;"]);
var getTooltip = exports.getTooltip = function getTooltip(item, measureName) {
  return /*#__PURE__*/_react["default"].createElement(PopoverContent, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: "auto"
    }
  }, /*#__PURE__*/_react["default"].createElement("small", null, item.key)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("small", null, measureName + ": "), /*#__PURE__*/_react["default"].createElement("strong", null, "" + item.value)));
};